import Icon from '../components/Icon.vue'

Icon.register({
  'temperature-high': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 0C363.1 0 320 43.1 320 96S363.1 192 416 192 512 148.9 512 96 468.9 0 416 0zM416 128C398.3 128 384 113.7 384 96S398.3 64 416 64 448 78.3 448 96 433.7 128 416 128zM256 112C256 50.1 205.9 0 144 0S32 50.1 32 112V278.5C12.3 303.2 0 334 0 368 0 447.5 64.5 512 144 512S288 447.5 288 368C288 334 275.7 303.1 256 278.5V112zM144 448C99.9 448 64 412.1 64 368 64 342.5 76.2 319.1 96 304.2V112C96 85.5 117.5 64 144 64S192 85.5 192 112V304.2C211.8 319 224 342.5 224 368 224 412.1 188.1 448 144 448zM160 322.9V112C160 103.2 152.8 96 144 96S128 103.2 128 112V322.9C109.4 329.5 96 347.1 96 368 96 394.5 117.5 416 144 416S192 394.5 192 368C192 347.1 178.6 329.5 160 322.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/temperature-high.js
// module id = St9p
// module chunks = 144